import api from './api';

import {CHANNELS_SET_ACTIVE} from './channels';

export const SEARCH_SET_PRODUCTS = 'SEARCH_SET_PRODUCTS';

const PRODUCTS_LIMIT = 6;

const initialState = {};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case SEARCH_SET_PRODUCTS:
      return {
        ...state,
        [payload.query]: payload.items
      };
    case CHANNELS_SET_ACTIVE:
      return initialState;
    default:
      return state;
  }
}

export function fetchSearchByQuery(query, page = 1, limit = PRODUCTS_LIMIT) {
  return dispatch => {
    dispatch({type: SEARCH_SET_PRODUCTS, payload: {query, items: null}});

    return dispatch(api.get(`products/`, {query, page, limit}))
      .then(
        searchResponse => dispatch({
          type: SEARCH_SET_PRODUCTS,
          payload: {query, items: searchResponse.content.items}
        }),
        searchError => {
          dispatch({
            type: SEARCH_SET_PRODUCTS,
            payload: {query, items: false}
          });

          throw searchError;
        }
      );
  };
}



// WEBPACK FOOTER //
// ./ducks/search.js